<template>
  <lu-vbox lu-flex class="drawer-container" :class="size + ' ' + 'labelfont-' + size">
    <lu-item class="drawer-title">Enviro setting</lu-item>

    <lu-hbox class="drawer-item" :class="size">
      <lu-item lu-flex>Open History view</lu-item>
      <lu-item><el-switch v-model="tagsView" class="drawer-switch lu-flex" /></lu-item>
    </lu-hbox>

    <lu-hbox class="drawer-item" :class="size">
      <lu-item lu-flex>Logo Show</lu-item>
      <lu-item><el-switch v-model="sidebarLogo" class="drawer-switch" /></lu-item>
    </lu-hbox>

    <!-- <lu-vbox lu-flex class="drawer-item vpad-in-5" :class="size">
      <lu-item>Theme</lu-item>
      <el-radio-group v-model="theme">
        <el-radio v-for="item in themeList" :key="item.id" :label="item.id" class='drawer-item' style='padding-bottom: 10px !important;'>{{ item.label}}</el-radio>
      </el-radio-group>
    </lu-vbox> -->

    <lu-vbox lu-flex class="drawer-item" :class="size">
      <lu-item>Page count</lu-item>
      <lu-item >
        <el-input-number class='inputNumber' :max='100' :min='1' style='width:150px !important;' v-model="pageSize" />
      </lu-item>
    </lu-vbox>

  </lu-vbox>
</template>

<script>
import { LuVbox, LuHbox, LuItem } from 'lusis-ui'
import { toggleClass } from '@/utils'
import { mapGetters } from 'vuex';

export default {
  components: { LuVbox, LuHbox, LuItem },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['themeList', 'size']),
    fixedHeader: {
      get() {
        return this.$store.state.settings.fixedHeader
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'fixedHeader',
          value: val
        })
      }
    },
    tagsView: {
      get() {
        return this.$store.state.settings.tagsView
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'tagsView',
          value: val
        })
      }
    },
    sidebarLogo: {
      get() {
        return this.$store.state.settings.sidebarLogo
      },
      set(val) {
        this.$store.dispatch('settings/changeSetting', {
          key: 'sidebarLogo',
          value: val
        })
      }
    },
    theme: {
      get() {
        return this.$store.state.tangoEnv.theme
      },
      set(val) {
        let oldVal = this.$store.state.tangoEnv.theme
        toggleClass(document.body, val, oldVal)
        this.$store.dispatch('tangoEnv/setTheme', val)
      }
    },
    pageSize: {
      get() {
        return this.$store.state.app.pageSize
      },
      set(val) {
        this.$store.dispatch('app/setPageSize', val)
      }
    }
  }
}
</script>

<style>
.inputNumber .el-input input {
  color: rgba(0, 0, 0, .65) !important;
}
</style>

<style lang="scss" scoped>
.drawer-container {
  padding: 24px;
  line-height: 1.5;
  word-wrap: break-word;

  .drawer-title {
    margin-bottom: 12px;
    color: rgba(0, 0, 0, .85);
    line-height: 22px;
  }

  .drawer-item {
    color: rgba(0, 0, 0, .65);
  }

  .medium {
      padding: 30px 0;
  }

  .base,
  .small,
  .mini {
      padding: 20px 0;
  }

  .drawer-switch {
    float: right
  }

  .inputNumber .el-input-number .el-input__inner {
    width: 50px !important;
    background: balck;
    color: rgba(0, 0, 0, .65) !important;
  }
}

</style>
